/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandAsana = createReactComponent("brand-asana", "IconBrandAsana", [
  ["path", { d: "M12 7m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-0" }],
  ["path", { d: "M17 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-1" }],
  ["path", { d: "M7 16m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0", key: "svg-2" }]
]);

export { IconBrandAsana as default };
//# sourceMappingURL=IconBrandAsana.js.map
